module.exports = "https://tutorchat.chegg.com/static/media/tutor-notify.3052679e.mp3";